<template>
  <v-container fluid class="instrumentos-page">
    <v-row justify="center">
      <v-col cols="12" md="11" lg="9" xl="8">
        <v-card class="instrumentos-card" elevation="4" rounded="lg">
          <v-card-title class="instrumentos-header">
            <div>
              <div class="text-h6 font-weight-bold">Instrumentos de Questionario</div>
              <div class="text-caption instrumentos-subtitle">
                Selecione o ano e visualize os instrumentos disponiveis.
              </div>
            </div>
          </v-card-title>

          <v-card-text>
            <v-text-field
              v-model="ano"
              label="Ano"
              type="number"
              outlined
              dense
              prepend-inner-icon="mdi-calendar"
              class="mb-2"
            ></v-text-field>

            <v-list v-if="listaInstrumentos && listaInstrumentos.length" two-line class="instrumentos-list">
              <v-list-item
                @click="selecionarInstumento(item)"
                v-for="item in listaInstrumentos"
                :key="item.id"
                class="instrumento-item"
              >
                <v-list-item-avatar color="indigo lighten-5" size="38">
                  <v-icon color="indigo darken-2">mdi-clipboard-text-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium item-title">{{ item.descricao }}</v-list-item-title>
                  <v-list-item-subtitle class="item-subtitle">ID: {{ item.id }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-alert v-else type="info" text border="left" colored-border color="indigo" class="mb-0">
              Nenhum instrumento encontrado no momento.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import { Libs } from "@/libs/libs";
import filtros from "@/libs/filters";
import { mapGetters, mapMutations } from "vuex";
import InstrumentoQuestionarioServices from "@/services/rh/InstrumentoQuestionarioServices";

export default {
  name: "SelecionarInstumentoQuestionario",
  data: () => ({}),
  components: {},
  filters: filtros,
  computed: {
    ...mapGetters({
      anoSelecionado: "avaliacao/anoSelecionado",
      listQuestionario: "avaliacao/listQuestionario",
      usuarioLogado: "config/getUsuarioLogado",
      listaInstrumentos: "avaliacao/getListaInstrumentos",
    }),
    ano: {
      get() {
        return this.anoSelecionado;
      },
      set(value) {
        this.setAnoSelecionado(value);
      },
    },
  },
  methods: {
    ...mapMutations({
      setAnoSelecionado: "avaliacao/setAnoSelecionado",
      setSelecionado: "avaliacao/setSelecionado",
      setInstrumentoSelecionado: "avaliacao/setInstrumentoSelecionado",
    }),
    async selecionarInstumento(item) {
      this.setSelecionado({
        id: null,
        id_instrumento: null,
        instrumento: "",
        anexo: "",
        ano: null,
        status: null,
        id_publico: null,
        grupo_resposta: "",
      });
      this.setInstrumentoSelecionado(item);
      await InstrumentoQuestionarioServices.loadQuestionariosInstrumento(this.ano, item.id);
      this.$router.push("/configurar-questionario");
    },
  },
  mounted: function () {
    this.ano = new Date().getFullYear();
    InstrumentoQuestionarioServices.LoadLista({anos:this.ano})
  },
};
</script>

<style scoped>
.instrumentos-page {
  padding-top: 16px;
  padding-bottom: 16px;
}

.instrumentos-card {
  width: 100%;
  border: 1px solid #e9edf5;
}

.instrumentos-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f7f9ff 0%, #eef3ff 100%);
  border-bottom: 1px solid #e4e9f6;
}

.instrumentos-subtitle {
  color: #5f6b82;
}

.instrumentos-list {
  border: 1px solid #ecf0f8;
  border-radius: 10px;
  overflow: hidden;
}

.instrumento-item {
  transition: background-color 0.2s ease;
}

.instrumento-item:hover {
  background-color: #f8faff;
}

.item-title {
  white-space: normal;
  word-break: break-word;
  line-height: 1.25;
}

.item-subtitle {
  margin-top: 2px;
}

@media (max-width: 600px) {
  .instrumentos-page {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .instrumentos-card {
    border-radius: 10px;
  }
}
</style>
